import React from "react";
import AscCircularProgressBar from "../../AscCircularProgressBar/AscCircularProgressBar";
import styles from "../AscAdminCSVUploader.module.scss";

interface IAscUploadLoader {
  percentage: number;
}

export default function AscUploadLoader({ percentage }: IAscUploadLoader) {
  return (
    <div className={styles.loading_bar}>
      <span className={styles.loading}>
        <AscCircularProgressBar color="#4239FB" percentage={percentage} />
      </span>
      <p>Uploading files ...</p>
    </div>
  );
}
